module.exports = __webpack_public_path__ + "img/组 49.81c2aad7.png";